import { useMemo } from 'react';
import useHelpNote from './useHelpNote';
export default function useHelpNoteTitle(title, tooltipTitle) {
    const getHelpNoteTooltipTitle = useHelpNote();
    return useMemo(() => tooltipTitle || getHelpNoteTooltipTitle(title || ''), [
        getHelpNoteTooltipTitle,
        title,
        tooltipTitle,
    ]);
}
